//REACT
import React from "react";

// STYLES
import * as Style from "./TimePickerAtomStyle";

// LIBRARIES
import { Dayjs } from "dayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

// MISC
import { IProps } from "./TimePickerAtomModel";

// ASSETS

// REDUX

// COMPONENTS

const TimePickerAtom = (props: IProps) => {
  // PROPS
  const { label = "", value = null, setValue = () => {} } = props;

  // CONSTANTS USING LIBRARIES

  // CONSTANTS USING HOOKS

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleChange = (newValue: Dayjs | null) => {
    setValue(newValue);
  };

  return (
    <Style.DateInputAtomContainer>
      <Style.LabelContainer>{label}</Style.LabelContainer>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TimePicker
          value={value}
          onChange={handleChange}
          renderInput={(params) => (
            <Style.TextFieldContainer
              {...params}
              inputProps={{
                ...params.inputProps,
                placeholder: "00:00 AM",
              }}
            />
          )}
        />
      </LocalizationProvider>
    </Style.DateInputAtomContainer>
  );
};

export default TimePickerAtom;
